import './Reviews.scss';
import '../Shared/Review/Review.scss';

import $ from 'jquery';

$(document).ready(function () {

    let visibleReviews = {};
    let filters = '.custom-select ul li';
    let reviews = '.reviews-list .review-wrap';
    let googleReviewsEl = $(filters + '[data-id=2]');
    let localReviewsEl = $(filters + '[data-id=1]');

    if (googleReviewsEl.length > 0) {
        $(filters).removeClass('selected');
        googleReviewsEl.addClass('selected');
    } else {
        $(filters).removeClass('selected');
        localReviewsEl.addClass('selected');
    }

    function showSelectedReviews(dataId) {

        let selectedReviews = $(reviews + '[data-id=' + dataId + ']');

        selectedReviews.each(function (idx, review) {
            if (idx < visibleReviews[dataId]) {
                $(review).removeClass('hidden');
            }
        });

        if (selectedReviews.length > visibleReviews[dataId]) {
            $('.js-add-more').show();
        } else {
            $('.js-add-more').hide();
        }
    }

    function selectFilter(el) {
        let id = el.data("id");

        $(filters).removeClass('selected');
        $(el).addClass('selected');

        $(reviews).each(function (idx, review) {
            $(review).addClass('hidden');
        });

        showSelectedReviews(id);

        // Showing Google reviews link
        if (id === 2) {
            $('.google-reviews-link').show();
        } else {
            $('.google-reviews-link').hide();
        }

        // Showing Yelp reviews link
        if (id === 7) {
            $('.yelp-reviews-link').show();
        } else {
            $('.yelp-reviews-link').hide();
        }

        $('.custom-selected').text($(el).text());
    }

    // Clear query string if not DemandForce tab selected
    function queryStringHandling(el) {
        let id = el.data("id");

        if (id !== 4) {
            window.history.pushState("", "Title", "/Reviews");
        }
    }

    //DemandForce pagination handling
    if (window.location.href.indexOf('d3cp_page') > -1) {
        let demandForceEl = $('.custom-select ul li[data-id=4]');

        if (demandForceEl.data("id") === 4) {
            selectFilter(demandForceEl);
        }
    }

    //open menu on mobile
    $('.custom-select').click(function (e) {
        e.stopPropagation();
        $(this).toggleClass('open');
    });

    $(window).click(function () {
        let el = $('.custom-select');
        if (el.hasClass('open')) {
            el.removeClass('open');
        }
    });

    //filter reviews
    $(filters).click(function () {
        let el = $(this);
        queryStringHandling(el);
        selectFilter(el);
    });

    //add more btn
    $('.js-add-more').click(function () {
        let dataId = $(filters + ".selected").data("id");

        visibleReviews[dataId] += 2;

        showSelectedReviews(dataId);
    });

    $(window).resize(function () {
        let el = $(filters + ".selected");
        selectFilter(el);
    });

    //set for each filter visibleReviews
    $(filters).each(function (idx, filter) {
        let dataId = $(filter).data('id');
        visibleReviews[dataId] = 10;
    });

    $(window).trigger('resize');
});


// WEBPACK FOOTER //
// ./Src/Reviews/Reviews.js